/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Edit_Reject_FailedInputs */

const en_samples_edit_reject_failed = /** @type {(inputs: Samples_Edit_Reject_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to reject sample`)
};

const es_samples_edit_reject_failed = /** @type {(inputs: Samples_Edit_Reject_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al rechazar muestra`)
};

/**
* | output |
* | --- |
* | "Failed to reject sample" |
*
* @param {Samples_Edit_Reject_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_edit_reject_failed = /** @type {((inputs?: Samples_Edit_Reject_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Edit_Reject_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_edit_reject_failed(inputs)
	return es_samples_edit_reject_failed(inputs)
});